import styled from "@emotion/styled"

const ListTwoCardContentWrapper = styled.div`
  ${({ theme }) => theme.breakpoints.down("lg")} {
    padding: 0 20px;
  }
`

export default ListTwoCardContentWrapper
